<template>
  <section class='confirm-container'>
    <span class='confirm-text'>{{ question }}</span>
    <mcw-button class='confirm-button' @click.stop="$emit('confirm')">
      <mcw-material-icon icon="check" class='on-right' />
      {{ positive }}
    </mcw-button>
    <mcw-button class='cancel-button' @click.stop="$emit('cancel')">
      <mcw-material-icon icon="cancel" class='on-right' />
      {{ negative }}
    </mcw-button>
  </section>
</template>

<script>
export default {
  name: 'InlineConfirmation',
  props: {
    question: {
      type: String,
      default: () => 'Отменить?',
    },
    positive: {
      type: String,
      default: () => 'Да',
    },
    negative: {
      type: String,
      default: () => 'Нет',
    },
  },
  emits: ['confirm', 'cancel'],
  data() {
    return {};
  },
};
</script>

<style scoped>
.confirm-container {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.confirm-text {
  margin-right: 8px;
  font-size: 14px;
}

.confirm-button {
  color: #f5f5f5 !important;
  background: var(--mdc-theme-primary)!important;
  min-width: 24px !important;
  padding: 0 8px !important;
}
.on-right {
  margin-right: 0.25rem;
}
.confirm-button i {
  color: #f5f5f5 !important;
}
i {
  color: var(--mdc-theme-primary)!important;
}
</style>
